<template>
  <div v-html="content ? content : (html ? html : '')"/>
</template>

<script>
export default {
  name: "html-section",
  props: {
    loadOnMounted: {
      type: Boolean,
      default: true
    },
    code: {
      type: String,
      default: null
    },
    html: {
      type: String,
      default: null
    }
  },
  mounted() {
    if (this.loadOnMounted) {
      this.load_content();
    }
  },
  methods: {
    async load_content() {
      try {
        this.content = null
        let data = await app.sdk['file']['app_content_read'](
            app.auth.token,
            {
              app_content_id: parseInt(this.code),
              code: this.code
            },
        );
        this.content = data.read[0] ? data.read[0].content_html : null;
        this.$emit("onLoad", this.content);
      } catch (err) {
        console.log('KS-APP: ', err);
        this.$emit("onError", err);
      }
    }
  },
  data() {
    return {
      content: null
    }
  }
}
</script>
